var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoMovie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light/Video",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Video"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M32.2534 30.4927L39.5834 33.4887C40.9754 34.0567 42.4994 33.0347 42.4994 31.5307V18.2527C42.4994 16.7487 40.9754 15.7247 39.5834 16.2927L32.2534 19.2887",
    stroke: "white",
    strokeWidth: 1.68616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    fillRule: "evenodd",
    "lip-rule": "evenodd",
    d: "M12.608 38.7817H25.146C29.514 38.7817 32.254 35.9357 32.254 31.9057V17.8757C32.254 13.8457 29.526 10.9997 25.146 10.9997H12.608C8.226 10.9997 5.5 13.8457 5.5 17.8757V31.9057C5.5 35.9357 8.226 38.7817 12.608 38.7817Z",
    stroke: "white",
    strokeWidth: 1.68616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMovie);
export default __webpack_public_path__ + "static/media/noMovie.46a57e591ffd81db7793cdbcfb4c67f8.svg";
export { ForwardRef as ReactComponent };